import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { SharedModule } from '../../../shared/shared.module';
import { DropdownModule } from '../dropdown/dropdown.module';
import { InputSelectComponent } from './input-select.component';

@NgModule({
  declarations: [InputSelectComponent],
  imports: [
    CommonModule,
    SharedModule,
    TranslateModule,
    FormsModule,
    ReactiveFormsModule,
    DropdownModule,
  ],
  exports: [InputSelectComponent],
})
export class InputSelectModule {}
